import FieldsInput from "../../../../components/FieldComponents/FieldsInput";
import { mergeClasses } from "@fluentui/react-components";
import Style from "../../../Client/ClientManagement/AddClient.style";
import { Stack } from "@fluentui/react";
import { useTranslation } from "react-i18next";

const UserState = (props) => {
  const { userState } = props;
  const { t } = useTranslation();
  const style = Style();
  return (
    <>
      <Stack className={style.client_field}>
        <FieldsInput
          label={t("state")}
          validationMessage={props.errors?.userState?.message}
          id="userState"
          placeholder={t("enter_state")}
          name="userState"
          inputDefaultValue={userState}
          inputClassName={mergeClasses(style.textboxInput)}
          validation={props.register("userState")}
          noRequired
        />
      </Stack>
    </>
  );
};

export default UserState;
